import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'pr-tab',
    templateUrl: './pr-tab.component.html',
    styleUrls: ['./pr-tab.component.scss'],
    standalone: false
})
export class PrTabComponent implements OnInit {
  @Input() label: any;
  @Input() icon: any;
  @Input() active = false;

  constructor() {}

  ngOnInit() {}
}
